<template>
<div class="form-part">
  <div class="row">
    <div class="col-5">
      <div class="row">
        <div class="col-4 label-left">
          <b-form-checkbox v-model="fields.mods_objname_sel" class="mt-1">Obj. Name</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-input v-model="fields.mods_objname" class="fit-width"></b-form-input>
        </div>
      </div>
    </div>
    <div class="col-7">
      <div class="row">
        <div class="col-4"></div>
        <div class="col-4 text-center">
          <div class="mt-2"><strong>Min</strong></div>
        </div>
        <div class="col-4 text-center">
          <div class="mt-2"><strong>Max</strong></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-5">
      <div class="row">
        <div class="col-4 label-left">
          <b-form-checkbox v-model="fields.mods_extended_imagetyp_sel" class="mt-1">Image Type</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-select v-model="fields.mods_extended_imagetyp" class="fit-width">
            <option :value="null">Select...</option>
            <option>OBJECT</option>
            <option>STD</option>
            <option>BIAS</option>
            <option>DARK</option>
            <option>ARC</option>
            <option>FLAT</option>
            <option>SKY FLAT</option>
            <option>IMAGING FLAT</option>
            <option>SLITLESS FLAT</option>
            <option>SLIT FLAT</option>
            <option>MOS FLAT</option>
          </b-form-select>
        </div>
      </div>
    </div>
    <div class="col-7">
      <div class="row">
        <div class="col-4 label-left">
          <b-form-checkbox v-model="fields.mods_airmass_sel" class="mt-1 ml-4">Air Mass</b-form-checkbox>
        </div>
        <div class="col-4">
          <b-form-input v-model="fields.mods_airmass_min" class="fit-width"></b-form-input>
          <span class="text-danger" v-if="fieldErrors.mods_airmass_min">{{fieldErrors.mods_airmass_min}}</span>
        </div>
        <div class="col-4">
          <b-form-input v-model="fields.mods_airmass_max" class="fit-width"></b-form-input>
          <span class="text-danger" v-if="fieldErrors.mods_airmass_max">{{fieldErrors.mods_airmass_max}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-5">
      <div class="row">
        <div class="col-4 label-left">
          <b-form-checkbox v-model="fields.mods_instrument_sel" class="mt-1">Instrument</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-select v-model="fields.mods_instrument" class="fit-width">
            <option :value="null">Select...</option>
            <option>MODS1</option>
            <option>MODS2</option>
          </b-form-select>
        </div>
      </div>
    </div>
    <div class="col-7">
      <div class="row">
        <div class="col-4 label-left">
          <b-form-checkbox v-model="fields.mods_posangle_sel" class="mt-1 ml-4">Pos. Angle</b-form-checkbox>
        </div>
        <div class="col-4">
          <b-form-input v-model="fields.mods_posangle_min" class="fit-width"></b-form-input>
          <span class="text-danger" v-if="fieldErrors.mods_posangle_min">{{fieldErrors.mods_posangle_min}}</span>
        </div>
        <div class="col-4">
          <b-form-input v-model="fields.mods_posangle_max" class="fit-width"></b-form-input>
          <span class="text-danger" v-if="fieldErrors.mods_posangle_max">{{fieldErrors.mods_posangle_max}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-5">
      <div class="row">
        <div class="col-4 label-left">
          <b-form-checkbox v-model="fields.mods_telescope_sel" class="mt-1">Telescope</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-select v-model="fields.mods_telescope" class="fit-width">
            <option :value="null">Select...</option>
            <option>LBT-DX</option>
            <option>LBT-SX</option>
          </b-form-select>
        </div>
      </div>
    </div>
    <div class="col-7">
    </div>
  </div>

  <div class="row">
    <div class="col-5">
      <div class="row">
        <div class="col-4 label-left">
          <b-form-checkbox v-model="fields.mods_maskpos_sel" class="mt-1">Mask Pos.</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-select v-model="fields.mods_maskpos" class="fit-width">
            <option :value="null">Select...</option>
            <option>IN</option>
            <option>STOW</option>
          </b-form-select>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-2">
      <label class="label-right">Mask type</label>
    </div>
    <div class="col-5">
      <b-form-radio-group v-model="fields.mods_masktype">
        <b-form-radio name="mods_masktype" value="standard" @change="modsMaskTypeChanged">Standard</b-form-radio>
        <b-form-radio name="mods_masktype" value="custom" @change="modsMaskTypeChanged">Custom</b-form-radio>
      </b-form-radio-group>
    </div>
  </div>

  <div class="row">
    <div class="col-5">
      <div class="row">
        <div class="col-4 label-left">
          <b-form-checkbox v-model="fields.mods_maskid_sel" class="mt-1">Mask Name</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-select v-model="fields.mods_maskid" class="fit-width" v-if="fields.mods_masktype === 'standard'">
            <option :value="null">Select...</option>
            <option>LS60x5</option>
            <option>LS5x60x0.3</option>
            <option>LS5x60x0.6</option>
            <option>LS5x60x0.8</option>
            <option>LS5x60x1.0</option>
            <option>LS5x60x1.2</option>
            <option>LS5x60x2.4</option>
            <option>Imaging</option>
            <option>SieveMask</option>
            <option>SudokuMask</option>
            <option>PinholeSlit</option>
            <option>PointingMask</option>
          </b-form-select>
          <b-form-input v-model="fields.mods_maskid" class="fit-width" v-if="fields.mods_masktype === 'custom'" placeholder="Custom name"></b-form-input>
        </div>
      </div>
    </div>
    <div class="col-5">
      <div class="row">
        <div class="col-4 ml-4 label-left">
          <b-form-checkbox v-model="fields.mods_ccdxybin_sel" class="mt-1">XBIN x YBIN</b-form-checkbox>
        </div>
        <div class="col-5">
          <b-form-select v-model="fields.mods_ccdxybin" class="fit-width">
            <option :value="null">Select...</option>
            <option>1 x 1</option>
            <option>1 x 2</option>
            <option>2 x 1</option>
            <option>2 x 2</option>
          </b-form-select>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-5">
      <div class="row">
        <div class="col-4 label-left">
          <b-form-checkbox v-model="fields.mods_gratname_sel" class="mt-1">Grat Name</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-select v-model="fields.mods_gratname" class="fit-width">
            <option :value="null">Select...</option>
            <option>FLAT</option>
            <option>G400L</option>
            <option>G670L</option>
            <option>P450L</option>
            <option>P700L</option>
            <option>grating</option>
            <option>prism</option>
          </b-form-select>
        </div>
      </div>
    </div>
    <div class="col-5">
      <div class="row">
        <div class="col-4 ml-4 label-left">
          <b-form-checkbox v-model="fields.mods_roi_sel" class="mt-1" title="Region Of Interest" v-b-tooltip.hover.left>ROI</b-form-checkbox>
        </div>
        <div class="col-5">
          <b-form-select v-model="fields.mods_roi" class="fit-width">
            <option :value="null">Select...</option>
            <option>8K x 3K</option>
            <option>4K x 3K</option>
            <option>3K x 3K</option>
            <option>1K x 1K</option>
          </b-form-select>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-5">
      <div class="row">
        <div class="col-4 label-left">
          <b-form-checkbox v-model="fields.mods_filtname_sel" class="mt-1">Filter Name</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-select v-model="fields.mods_filtname" class="fit-width">
            <option :value="null">Select...</option>
            <option>Clear</option>
            <option>r_sdss</option>
            <option>g_sdss</option>
            <option>u_sdss</option>
            <option>i_sdss</option>
            <option>z_sdss</option>
            <option>GG495</option>
            <option>ND1.5</option>
            <option>UG5</option>
          </b-form-select>
        </div>
      </div>
    </div>
    <div class="col-7">
    </div>
  </div>

  <div class="row">
    <div class="col-5">
      <div class="row">
        <div class="col-4 label-left">
          <b-form-checkbox v-model="fields.mods_dichname_sel" class="mt-1">Dichr. Name</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-select v-model="fields.mods_dichname" class="fit-width">
            <option :value="null">Select...</option>
            <option>Dual</option>
            <option>Blue</option>
            <option>Red</option>
          </b-form-select>
        </div>
      </div>
    </div>
    <div class="col-7">
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Mods',
  computed: mapState({
    fields: state => state.searchForm.fields,
    fieldErrors: state => state.searchForm.fieldErrors
  }),
  methods: {
    modsMaskTypeChanged() {
      this.fields.mods_maskid = null;
    }
  }
}
</script>
